const mutationTypes = {
  SET_SELECTED_ORDER: 'setSelectedOrder'
};

const state = {
  selectedOrder: null
};

const mutations = {
  [mutationTypes.SET_SELECTED_ORDER]: (state, selectedOrder) => {
    state.selectedOrder = selectedOrder;
  }
};

const actions = {
  setSelectedOrder: ({commit}, selectedOrder) => {
    commit(mutationTypes.SET_SELECTED_ORDER, selectedOrder);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};